<template>
  <router-view />
</template>

<script>
export default {
  name: 'KernelPackageReturnsWrapper',
};
</script>
